module.exports = __webpack_public_path__ + "img/kareha1.851b3ac8.jpg";